<template>
    <div class="ui-page">
        <ui-page-header title="Análise em massa" subtitle="Envio de arquivos para aprovar ou rejeitar divergências em lote."
            back="/divergencias" back-text="Divergências">
            <v-btn v-if="$allowed('event.decide')" color="primary" depressed :loading="dataset.loading" @click="uploadFile">Enviar</v-btn>
        </ui-page-header>

        <v-form ref="form" v-model="dataForm.validForm">
            <ui-section title="Arquivos">
                <v-banner single-line outlined class="mb-4">
                    <v-icon slot="icon" color="warning" size="36">mdi-alert-outline</v-icon>

                    O nome do(s) arquivo(s) deve(m) estar formatado(s) da seguinte forma: "cpf-numerocredor-status.extensão"

                    <v-tooltip bottom>
                        <template #activator="{ on }">
                            <v-btn v-on="on" text @click="showDetails = !showDetails" color="primary" elevation="0" outlined dense style="height: 24px;">
                                {{ showDetails ? 'Menos Detalhes' : 'Mais Detalhes' }}
                            </v-btn>
                        </template>
                        <span>Informações adicionais</span>
                    </v-tooltip>

                    <div v-if="showDetails">
                        <ul>
                            <li><strong>CPF</strong>: 11 dígitos sem pontuação ou traço (ex: 12345678900)</li>
                            <li><strong>Credor</strong>: número identificador do credor no sistema (ex: 123)</li>
                            <li><strong>Status</strong>: "aprovado" ou "rejeitado"</li>
                            <li><strong>Extensão</strong>: ".csv", ".xlsx", ".docx", etc.</li>
                        </ul>
                        <br>
                        <p>Exemplos de nomes válidos:</p>
                        <ul>
                            <li>12345678900-123-aprovado.csv</li>
                            <li>09876543210-456-rejeitado.xlsx</li>
                        </ul>
                    </div>
                </v-banner>

                <div
                    class="drop-area"
                    @drop.prevent="onDrop($event)"
                    @dragover.prevent="dragover = true"
                    @dragenter.prevent="dragover = true"
                    @dragleave.prevent="dragover = false"
                    :class="{ 'grey lighten-2': dragover }"
                    >
                    <p v-if="uploadedFiles.length == 0" class="text-center">
                        Arraste e solte seus arquivos aqui!
                    </p>
                    <v-virtual-scroll
                        v-if="uploadedFiles.length > 0"
                        :items="uploadedFiles"
                        height="500"
                        item-height="50"
                        >
                        <template v-slot:default="{ item }">
                            <v-list-item :key="item.name">
                                <v-list-item-content>
                                    <v-list-item-title>
                                        {{ item.name }}
                                        <span class="ml-3 text--secondary">
                                            {{ item.size }} bytes
                                        </span>
                                    </v-list-item-title>
                                </v-list-item-content>
                                <v-list-item-action>
                                    <v-btn @click.stop="removeFile(item.name)" icon>
                                        <v-icon> mdi-close-circle </v-icon>
                                    </v-btn>
                                </v-list-item-action>
                            </v-list-item>
                            <v-divider></v-divider>
                        </template>
                    </v-virtual-scroll>
                </div>
                <div class="file-count">
                    Total de arquivo(s): <strong>{{ fileCount }}</strong>
                </div>

                <v-progress-linear v-if="dataset.progress" v-model="dataset.progress" color="green" height="25"
                    reactive class="mt-4">
                    <strong>{{ dataset.progress }} %</strong>
                </v-progress-linear>
            </ui-section>
        </v-form>
    </div>
</template>

<script>

import Vue from "vue";
import VueLodash from 'vue-lodash'
import _ from 'lodash';
import axios from 'axios';

Vue.use(VueLodash)

export default {
    name: "bulkAnalysis",
    props: {
    multiple: {
      type: Boolean,
      default: true,
    },
  },
    data() {
        return {
            dataset: {
                data: {},
                progress: null,
                loading: false,
            },
            formDataUpload: [],

            dataForm: {
                validForm: true,
            },
            currFiles: [],
            previousFiles: [],
            files: [],
            uploadedFiles: [],
            dragover: false,
            fileCount: 0,
            showDetails: false,
        }
    },

   
    watch: {
        files(val) {
            this.previousFiles = val
        }  
    },

    methods: {

        goBack() {
            this.$router.replace("/divergencias");
        },


        onDrop(e) {

            e.dataTransfer.files.forEach(file => {
                if (!this.fileExists(file.name)) {
                    this.uploadedFiles.push(file);
                }
            });

            this.updateFileCount();

        },

        fileExists(fileName) {
            return this.uploadedFiles.some(file => file.name === fileName);
        },

        removeFile(fileName) {
            const index = this.uploadedFiles.findIndex(
                file => file.name === fileName
            );
            if (index > -1) this.uploadedFiles.splice(index, 1);

            this.updateFileCount();
        },

        updateFileCount() {
        this.fileCount = this.uploadedFiles.length;
        },

        async uploadFile() {

            if (!this.$refs.form.validate()) return;

            const proceedAction = await this.$dialog.confirm({
                text: 'Deseja enviar a lista de arquivos para analise?',
                title: 'Enviar arquivos',
                actions: {
                    false: 'Cancelar',
                    true: 'Enviar'
                }
            })

            if (!proceedAction) return;


            if(this.uploadedFiles.length == 0){
                this.$dialog.notify.error("Nenhum arquivo selecionado para envio!", { position: "top-right", timeout: 3000 });
                return
            }
            
            this.dataset.loading = true;
            this.dataset.progress = 0;

            try {

                const payload = this.buildPayload()

                const response = await axios.post('/api/admin/bulk-reviews', payload, {
                    onUploadProgress: (event) => {
                        this.dataset.progress = Math.round((100 * event.loaded) / event.total);
                    }
                })

                this.$dialog.notify.info("Arquivo(s) enviado(s) com sucesso!", { position: "top-right", timeout: 3000 });

                this.goBack()

            } catch (error) {
                console.log('error ', error)
                this.$dialog.notify.error(this.$codes(error), {
                    position: 'top-right',
                    timeout: 2000
                })
            } finally {
                this.dataset.loading = false;
                this.dataset.progress = 0;
            }
        },

        buildPayload() {

            this.formDataUpload = new FormData();

            for (let i = 0; i < this.uploadedFiles.length; i++) {
                this.formDataUpload.append(`files[${i}]`, this.uploadedFiles[i]);
            }

            return this.formDataUpload;
        }

    }

};
</script>


<style>

.drop-area {
    border: 2px dashed #757575;
    padding: 20px;
    text-align: left;
}

.file-count {
    margin-top: 10px;
    font-size: 14px;
    text-align: right;
}
</style>